import { _ as _objectSpread2, a as _toConsumableArray } from '../../_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_state_quote = {
  show_plans: false,
  captureMode: 'create',
  quotationNo: '',
  quotationType: 'New Business',
  quotationStatus: '',
  quoteCreationDate: '',
  proposalNumber: '',
  currentTab: 'members',
  isQuoteSaving: false,
  isCopyFromOutside: false,
  members: [{
    selected: false,
    relationship: 'Self',
    gender: '',
    maternitySelected: false,
    maternitycover: false,
    pedWaitingPeriod: '36 Months',
    waitingPeriod: false
  }, {
    selected: false,
    relationship: 'Spouse',
    gender: '',
    maternitySelected: false,
    maternitycover: false,
    pedWaitingPeriod: '36 Months',
    waitingPeriod: false
  }, {
    selected: false,
    relationship: 'Father',
    gender: 'MALE',
    maternitySelected: false,
    maternitycover: false,
    pedWaitingPeriod: '36 Months',
    waitingPeriod: false
  }, {
    selected: false,
    relationship: 'Mother',
    gender: 'FEMALE',
    maternitySelected: false,
    maternitycover: false,
    pedWaitingPeriod: '36 Months',
    waitingPeriod: false
  }],
  maternityMembers: [],
  isQuoteCopied: true,
  maternitySelectedCover: false,
  location: {
    pincode: '',
    state: '',
    district: '',
    city: '',
    zone: ''
  },
  isExistingEmployee: 'No',
  existingPolicyNumber: '',
  cover: {
    type: '',
    sum_insured: '',
    tenure: ''
  },
  intermediaryDetails: {
    code: '',
    location: '',
    fieldUserCode: '',
    fieldUserName: ''
  },
  deductSumInsured: "",
  customer: {},
  customerMeta: {},
  isPlanLoading: false,
  isCoverPageLoading: false
};
var init_state_plans = {
  plans: [],
  isCoversLoading: true,
  plansChanged: []
};
var healthQuoteVar = makeVar(init_state_quote);
var healthPlansVar = makeVar(init_state_plans);
var initHealthQuoteState = function initHealthQuoteState(isCopyFromOutside) {
  var _healthQuoteVar;

  if (isCopyFromOutside && (_healthQuoteVar = healthQuoteVar()) !== null && _healthQuoteVar !== void 0 && _healthQuoteVar.isCopyFromOutside) {
    healthQuoteVar(_objectSpread2(_objectSpread2({}, healthQuoteVar()), {}, {
      isCopyFromOutside: false
    }));
    return true;
  }

  healthQuoteVar(init_state_quote);
  return false;
};
var initHealthPlansState = function initHealthPlansState() {
  return healthPlansVar(init_state_plans);
};
var updateHealthQuote = function updateHealthQuote(data) {
  return healthQuoteVar(_objectSpread2(_objectSpread2(_objectSpread2({}, healthQuoteVar()), data), {}, {
    show_plans: true
  }));
};
var updateCustomerInformation = function updateCustomerInformation(customerInformation) {
  return healthQuoteVar(_objectSpread2(_objectSpread2({}, healthQuoteVar()), {}, {
    customer: customerInformation !== null && customerInformation !== void 0 && customerInformation.customer ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customer : {},
    customerMeta: customerInformation !== null && customerInformation !== void 0 && customerInformation.customerMeta ? customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.customerMeta : {}
  }));
};
var updateHealthQuotePlans = function updateHealthQuotePlans(plans, isSelected) {
  return healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
    isCoversLoading: false,
    plans: plans.map(function (plan) {
      var _ref;

      return _objectSpread2(_objectSpread2({}, plan), {}, {
        isSelected: (_ref = [true, false]) !== null && _ref !== void 0 && _ref.includes(isSelected) ? isSelected : false,
        premium: plan.premium ? plan.premium : null,
        isCalculatingPremium: true
      });
    })
  }));
};
var updateSelectedPlans = function updateSelectedPlans(planName, isSelected) {
  var _healthPlansVar, _healthPlansVar$plans;

  var idxPlan = (_healthPlansVar = healthPlansVar()) === null || _healthPlansVar === void 0 ? void 0 : (_healthPlansVar$plans = _healthPlansVar.plans) === null || _healthPlansVar$plans === void 0 ? void 0 : _healthPlansVar$plans.findIndex(function (plan) {
    var _plan$name, _plan$name$toString, _planName$toString;

    return (plan === null || plan === void 0 ? void 0 : (_plan$name = plan.name) === null || _plan$name === void 0 ? void 0 : (_plan$name$toString = _plan$name.toString()) === null || _plan$name$toString === void 0 ? void 0 : _plan$name$toString.toLowerCase()) === (planName === null || planName === void 0 ? void 0 : (_planName$toString = planName.toString()) === null || _planName$toString === void 0 ? void 0 : _planName$toString.toLowerCase());
  });

  if (idxPlan !== -1) {
    var _healthPlansVar2, _healthPlansVar2$plan, _healthPlansVar3, _healthPlansVar4, _healthPlansVar4$plan;

    return healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
      plans: [].concat(_toConsumableArray((_healthPlansVar2 = healthPlansVar()) === null || _healthPlansVar2 === void 0 ? void 0 : (_healthPlansVar2$plan = _healthPlansVar2.plans) === null || _healthPlansVar2$plan === void 0 ? void 0 : _healthPlansVar2$plan.slice(0, idxPlan)), [_objectSpread2(_objectSpread2({}, (_healthPlansVar3 = healthPlansVar()) === null || _healthPlansVar3 === void 0 ? void 0 : _healthPlansVar3.plans[idxPlan]), {}, {
        isSelected: isSelected,
        isCalculatingPremium: false
      })], _toConsumableArray((_healthPlansVar4 = healthPlansVar()) === null || _healthPlansVar4 === void 0 ? void 0 : (_healthPlansVar4$plan = _healthPlansVar4.plans) === null || _healthPlansVar4$plan === void 0 ? void 0 : _healthPlansVar4$plan.slice(idxPlan + 1)))
    }));
  }
};
var updateHealthQuotePlansPremium = function updateHealthQuotePlansPremium(planName, premium) {
  healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
    plans: healthPlansVar().plans.map(function (plan) {
      return plan.name === planName ? _objectSpread2(_objectSpread2({}, plan), {}, {
        isSelected: true,
        premium: premium,
        isCalculatingPremium: false
      }) : plan;
    }),
    plansChanged: healthPlansVar().plansChanged.filter(function (changed) {
      return changed !== planName;
    })
  }));
};
var removeEntirePack = function removeEntirePack(packName, planName) {
  healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
    plans: healthPlansVar().plans.map(function (p) {
      return p.name === planName ? _objectSpread2(_objectSpread2({}, p), {}, {
        packs: p.packs.map(function (pack) {
          return pack.name === packName ? _objectSpread2(_objectSpread2({}, pack), {}, {
            addOnCovers: pack.addOnCovers.map(function (add) {
              return _objectSpread2(_objectSpread2({}, add), {}, {
                selected: false
              });
            })
          }) : pack;
        })
      }) : p;
    }),
    plansChanged: healthPlansVar().plansChanged.includes(planName) ? healthPlansVar().plansChanged : [].concat(_toConsumableArray(healthPlansVar().plansChanged), [planName])
  }));
};
var addEntirePack = function addEntirePack(packName, planName) {
  healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
    plans: healthPlansVar().plans.map(function (p) {
      return p.name === planName ? _objectSpread2(_objectSpread2({}, p), {}, {
        packs: p.packs.map(function (pack) {
          return pack.name === packName ? _objectSpread2(_objectSpread2({}, pack), {}, {
            addOnCovers: pack.addOnCovers.map(function (add) {
              return _objectSpread2(_objectSpread2({}, add), {}, {
                selected: true
              });
            })
          }) : pack;
        })
      }) : p;
    }),
    plansChanged: healthPlansVar().plansChanged.includes(planName) ? healthPlansVar().plansChanged : [].concat(_toConsumableArray(healthPlansVar().plansChanged), [planName])
  }));
};
var toggleAddOn = function toggleAddOn(addOnName, packName, planName) {
  healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
    plans: healthPlansVar().plans.map(function (p) {
      var _p$packs, _p$packs$find, _p$packs$find$addOnCo, _p$packs$find$addOnCo2;

      return p.name === planName ? _objectSpread2(_objectSpread2({}, p), {}, {
        isSelected: !(p !== null && p !== void 0 && (_p$packs = p.packs) !== null && _p$packs !== void 0 && (_p$packs$find = _p$packs.find(function (pack) {
          return (pack === null || pack === void 0 ? void 0 : pack.name) === packName;
        })) !== null && _p$packs$find !== void 0 && (_p$packs$find$addOnCo = _p$packs$find.addOnCovers) !== null && _p$packs$find$addOnCo !== void 0 && (_p$packs$find$addOnCo2 = _p$packs$find$addOnCo.find(function (add) {
          return (add === null || add === void 0 ? void 0 : add.name) === addOnName;
        })) !== null && _p$packs$find$addOnCo2 !== void 0 && _p$packs$find$addOnCo2.selected) && !(p !== null && p !== void 0 && p.isSelected) ? true : p === null || p === void 0 ? void 0 : p.isSelected,
        premium: null,
        packs: p.packs.map(function (pack) {
          return pack.name === packName ? _objectSpread2(_objectSpread2({}, pack), {}, {
            addOnCovers: pack.addOnCovers.map(function (add) {
              return add.name === addOnName ? _objectSpread2(_objectSpread2({}, add), {}, {
                selected: !add.selected
              }) : add;
            })
          }) : pack;
        })
      }) : p;
    }),
    plansChanged: healthPlansVar().plansChanged.includes(planName) ? healthPlansVar().plansChanged : [].concat(_toConsumableArray(healthPlansVar().plansChanged), [planName])
  }));
};
var resetPlansChanged = function resetPlansChanged() {
  healthPlansVar(_objectSpread2(_objectSpread2({}, healthPlansVar()), {}, {
    plansChanged: []
  }));
};
var updateQuotationDetails = function updateQuotationDetails(quotationNo, quotationStatus, quoteCreationDate) {
  healthQuoteVar(_objectSpread2(_objectSpread2({}, healthQuoteVar()), {}, {
    quotationNo: quotationNo,
    quotationStatus: quotationStatus,
    quoteCreationDate: quoteCreationDate
  }));
};

export { addEntirePack, healthPlansVar, healthQuoteVar, initHealthPlansState, initHealthQuoteState, init_state_plans, init_state_quote, removeEntirePack, resetPlansChanged, toggleAddOn, updateCustomerInformation, updateHealthQuote, updateHealthQuotePlans, updateHealthQuotePlansPremium, updateQuotationDetails, updateSelectedPlans };
